import { render, staticRenderFns } from "./Delete.vue?vue&type=template&id=42a3ba8a&scoped=true&"
import script from "./Delete.vue?vue&type=script&lang=ts&"
export * from "./Delete.vue?vue&type=script&lang=ts&"
import style0 from "./Delete.vue?vue&type=style&index=0&id=42a3ba8a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42a3ba8a",
  null
  
)

export default component.exports